import isEmpty from 'lodash/isEmpty';
import has from 'lodash/has';

export const transformDowngradeConflicts = (conflicts, page = 0) => {
    if (
        isEmpty(conflicts) ||
        !has(conflicts, 'downgradeConflicts') ||
        isEmpty(conflicts.downgradeConflicts[page])
    ) {
        return null;
    }

    const { pagination = {}, downgradeConflicts = [] } = conflicts;

    return {
        pagination,
        conflicts: downgradeConflicts[page],
    };
};
